import { ClaimV2CornSchema } from '@eigtech/claims-v2-types';
import { JobCornSchema } from '@eigtech/restoration-types';
import { z } from 'zod';
import { EstimateCornSchema, LineItemCornSchema } from './corn.js';
import { EstimateClassSchema, ItemActionSchema, LineKindSchema, isoDateTime, money, qty, } from './primitives.js';
export const BaseCoverageSchema = z.object({
    id: z.string(),
    name: z.string(),
    deductible: money.optional(),
    replacementCost: money.optional(),
    actualCashValue: money.optional(),
    recoverableDepreciation: money.optional(),
    nonRecoverableDepreciation: money.optional(),
});
export const BaseLineItemSchema = z.object({
    action: ItemActionSchema.optional(),
    actionLabel: z.string().optional(),
    actualCashValue: money.optional(),
    category: z.string().optional(),
    coverageId: z.string().optional(),
    coverageName: z.string().optional(),
    depreciation: money.optional(),
    description: z.string(),
    equipment: money.optional(),
    groupId: z.string().optional(),
    groupLabel: z.string().optional(),
    id: z.string(),
    kind: LineKindSchema.default('lineItem'),
    labor: money.optional(),
    lineNumber: qty.optional(),
    lineItemCorn: LineItemCornSchema.optional(),
    material: money.optional(),
    note: z.string().optional(),
    quantity: qty.optional(),
    recoverable: z.boolean().optional(),
    replacementCost: money.optional(),
    selector: z.string().optional(),
    tax: money.optional(),
    total: money.optional(),
    unitOfMeasure: z.string().optional(),
});
export const BaseEstimateDatesSchema = z.object({
    loss: isoDateTime,
    created: isoDateTime.optional(),
    inspected: isoDateTime.optional(),
    completed: isoDateTime.optional(),
    received: isoDateTime.optional(),
    entered: isoDateTime.optional(),
    contacted: isoDateTime.optional(),
});
export const BaseEstimateTotalsSchema = z.object({
    replacementCost: money,
    actualCashValue: money,
    deductible: money.optional(),
    recoverableDepreciation: money.optional(),
    nonRecoverableDepreciation: money.optional(),
    tax: money.optional(),
    subtotal: money.optional(),
});
export const BaseEstimateSchema = z.object({
    claimNumber: z.string().optional(),
    coverages: z.array(BaseCoverageSchema).optional(),
    dates: BaseEstimateDatesSchema.optional(),
    entityId: ClaimV2CornSchema.or(JobCornSchema),
    estimateClass: EstimateClassSchema.optional(),
    estimateId: EstimateCornSchema,
    insuredName: z.string().optional(),
    items: z.array(BaseLineItemSchema).optional(),
    name: z.string().min(1),
    policyNumber: z.string().optional(),
    totals: BaseEstimateTotalsSchema.optional(),
    typeOfLoss: z.string().optional(),
});
